<template>
    <div>
        <b-card no-body>
            <b-card-header class="border-0 pt-3 px-3 pb-0">
                <b-row align-v="center">
                    <b-col cols="10" class="d-flex align-items-center">
                        <h3 class="mb">I am looking for core product:</h3>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-container class="pb-3">
                <b-row>
                    <b-col cols="12">
                        <el-radio-group v-model="looking_for_product">
                            <b-row>
                                <b-col cols="12">
                                    <el-radio label="property">Property</el-radio>
                                </b-col>
                                <b-col cols="12">
                                    <el-radio label="mortgage">Mortgage</el-radio>
                                </b-col>
                                <b-col cols="12">
                                    <el-radio label="personal_loan">Personal Loan</el-radio>
                                </b-col>
                                <b-col cols="12">
                                    <el-radio label="insurance">Insurance</el-radio>
                                </b-col>
                                <b-col cols="12">
                                    <el-radio label="refinance">Refinance</el-radio>
                                </b-col>
                                <b-col cols="12">
                                    <el-radio label="other">Other Cases</el-radio>
                                </b-col>
                            </b-row>
                        </el-radio-group>
                    </b-col>
                </b-row>
                <div class="text-right mt-2">
                    <el-button class="bg-primary py-2 px-3 text-white" @click="save" :loading="is_loading_save">Save</el-button>
                </div>
            </b-container>
        </b-card>
    </div>
</template>
<script>
    import { RadioGroup, Radio,  Button } from 'element-ui'
		import { mapState } from 'pinia'
    import {
        notifyFunctionMixin,
        helperFunctionMixin,
        axios,
        services,
        getHeader
    } from '@/assets/js/httpImports.js'
		import { useCustomerStore } from '@/stores/customerStore'

    export default {
				name: 'looking-for-product',
        components: {
            [Button.name]: Button,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
        },
        mixins:[
            notifyFunctionMixin,
            helperFunctionMixin
        ],
        data() {
            return {
                looking_for_product:'',
                is_loading_save: false
            }
        },
				computed: {
            ...mapState(useCustomerStore,['current_customer','getCustomer'])
        },
        watch:{
						current_customer:{
                handler(newVal){
                    if(!this.isEmpty(newVal) && !this.isEmpty(newVal.additional_detail) && !this.isEmpty(newVal.additional_detail.looking_for_product)){
                        this.looking_for_product = newVal.additional_detail.looking_for_product
                    }
                },
                immediate: true
            }
        },
        methods: {
            save(){
                let data = {
                    "looking_for_product": this.looking_for_product   
                }

                this.is_loading_save = true
                axios.post(services.customer + 'customer/'+this.current_customer.customer_id+'/additional-details', data, {headers: getHeader()})
                    .then(res=>{
                        this.is_loading_save = false
                        this.notifySuccess('<b>Customer Looking For</b> - Successfully Updated.')
												this.getCustomer(this.current_customer.customer_id);
                    })
                    .catch(e =>{
                        this.is_loading_save = false
                        this.errorFunction(e)
                    })                    
            }
        }
    }
</script>